<template>
    <div :style="`height: ${height}`">
        <div id="myGrid" class="ag-theme-alpine" style="height: 100%;">
            <div v-show="false" ref="actions">
                <slot name="actions"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MGrid",
    props: {
        fields: {
            type: Array,
            default: null
        },
        model: {
            type: String,
            default: null
        },
        height: {
            required: false,
            type: String,
            default: '600px'
        },
        rowHeight: {
            required: false,
            type: Number,
            default: 50
        },
    },
    data() {
        return {
            gridDiv: null,
            grid: null,
            docEl: null,
            isSmall: false,
            colNames: [],
            booleanValues: [true, "true", false, "false"],
            size: 'fill',
            width: '100%',
            rowSelection: 'checkbox',
            /*groupColumn: {
                headerName: "Group",
                width: 250,
                field: 'name',
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                cellRenderer: 'agGroupCellRenderer',
                cellRendererParams: {
                    checkbox: true
                }
            },*/
            formatter: new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            }),
            defaultExportParams: {
                skipColumnGroupHeaders: true,
                headerRowHeight: 40,
                rowHeight: 30,
                fontSize: 14,
                addImageToCell: function (rowIndex, column, value) {

                }
            },
            gridOptions: null,
            desktopDefaultCols: [],
            defaultCols: null,
            defaultColCount: null,
            dataSize: 0,
            loadInstance: 0,

        }
    },
    methods: {

        refreshGrid() {
            if (this.grid) {
                this.grid.destroy();
            }

            agGrid.LicenseManager.setLicenseKey('1607933882236');

            this.grid = new agGrid.Grid(this.gridDiv, this.gridOptions);
            let app = this;
            var dataSource = {
                rowCount: null, // behave as infinite scroll

                getRows: function (params) {
                    console.log(JSON.stringify(params.request, null, 1));
                    let url = '/grid/' + app.model;
                    fetch(url, {
                        method: 'post',
                        body: JSON.stringify(params.request),
                        headers: {
                            'Content-Type': 'application/json; charset=utf-8',
                            "X-CSRF-Token": window.axios.defaults.headers.common['X-CSRF-TOKEN']
                        }
                    })
                        .then(httpResponse => httpResponse.json())
                        .then(response => {
                            params.successCallback(response.rows, response.total);
                            //app.createData();
                        })
                        .catch(error => {
                            console.error(error);
                            params.failCallback();
                        })
                },
            };


            this.gridOptions.api.setServerSideDatasource(dataSource);
            this.gridOptions.api.hideOverlay();



            // this.createData();
        },
        onThemeChanged(initial) {
            this.gridDiv.className = 'ag-theme-alpine';
            this.refreshGrid();
        },
        axisLabelFormatter(params) {
            var value = params.value;
            var isNormalized = falgridOptionsse;
            var hasBarSeries = false;
            var hasScatterSeries = false;
            var hasHistogramSeries = false;
            var hasAreaSeries = false;
            var hasLineSeries = false;
            var flipXY = false;
            params.axis.boundSeries.forEach(function (series) {
                if (series.normalizedTo) {
                    isNormalized = true;
                }
                if (series.type === 'bar') {
                    hasBarSeries = true;
                    flipXY = series.flipXY;
                } else if (series.type === 'scatter') {
                    hasScatterSeries = true;
                } else if (series.type === 'histogram') {
                    hasHistogramSeries = true;
                } else if (series.type === 'area') {
                    hasAreaSeries = true;
                } else if (series.type === 'line') {
                    hasLineSeries = true;
                }
            });

            if (isNaN(value)) {
                return value;
            }
            if (isNormalized) {
                return value + '%';
            }

            var absolute = Math.abs(value);
            var standardised = '';

            if (absolute < 1e3) {
                standardised = absolute;
            }
            if (absolute >= 1e3 && absolute < 1e6) {
                standardised = '$' + +(absolute / 1e3).toFixed(1) + 'K';
            }
            if (absolute >= 1e6 && absolute < 1e9) {
                standardised = '$' + +(absolute / 1e6).toFixed(1) + 'M';
            }
            if (absolute >= 1e9 && absolute < 1e12) {
                standardised = '$' + +(absolute / 1e9).toFixed(1) + 'B';
            }
            if (absolute >= 1e12) standardised = '$' + +(absolute / 1e12).toFixed(1) + 'T';

            if (hasScatterSeries || (hasAreaSeries || hasLineSeries) && params.axis.direction === 'y' || hasHistogramSeries && params.axis.direction === 'x' || hasBarSeries && (flipXY && params.axis.direction === 'x' || !flipXY && params.axis.direction === 'y')) {
                return value < 0 ? '-' + standardised : standardised;
            } else {
                return value;
            }
        },
        suppressColumnMoveAnimation() {
            var isFirefox = typeof InstallTrigger !== 'undefined';
            // At least Safari 3+: "[object HTMLElementConstructor]"
            var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
            // Internet Explorer 6-11
            var isIE = /*@cc_on!@*/false || !!document.documentMode;

            return isFirefox || isSafari || isIE;
        },
        getContextMenuItems(params) {
            var result = params.defaultItems ? params.defaultItems.splice(0) : [];
            result.push(
                {
                    name: 'Custom Menu Item',
                    icon: '<img src="images/lab.svg" style="width: 14px; height: 14px;"/>',
                    //shortcut: 'Alt + M',
                    action: function () {
                        var value = params.value ? params.value : '<empty>';
                        //window.alert('You clicked a custom menu item on cell ' + value);
                    }
                }
            );

            return result;
        },
        filterDoubleClicked(event) {
            setInterval(function () {
                this.gridOptions.api.ensureIndexVisible(Math.floor(Math.random() * 100000));
            }, 4000);
        },
        toggleToolPanel() {
            var showing = this.gridOptions.api.isToolPanelShowing();
            this.gridOptions.api.showToolPanel(!showing);
        },


        setAction(params) {
            if (params.value == null || params.value === "" || params.value === '(Select All)') {
                return params.value;
            }

            let html = this.$refs['actions'].innerHTML;

            html = html.replaceAll(':id', params.value)
            return html;
        },
        ishtml(params) {
            if (params.value == null || params.value === "" || params.value === '(Select All)') {
                return params.value;
            }
            var t = document.createElement('template');
            t.innerHTML = params.value;
            return t.content;
        }
    },
    mounted() {
        this.gridDiv = document.getElementById('myGrid');

        var app = this;
        this.docEl = document.documentElement
        this.isSmall = app.docEl.clientHeight <= 415 || app.docEl.clientWidth < 768;
        if (this.fields) {
            this.fields.forEach(function (field) {
                let col = {
                    headerName: field["title"],
                    field: field["name"],
                    editable: false,
                    flex: 1,
                    filter:'agTextColumnFilter',
                    enableValue: false,
                    enableRowGroup: false,
                }

                if (field.hasOwnProperty('filter')) {
                    col.filter = field["filter"];
                }

                if (field.hasOwnProperty('filterParams')) {
                    col.filterParams =  {
                        values: field["filterParams"]
                    }
                }

                if (field.hasOwnProperty('group')) {
                    col.enableRowGroup = field["group"];
                }

                if (field.hasOwnProperty('sortable')) {
                    col.sortable = field["sortable"];
                }

                if (field.hasOwnProperty('flex')) {
                    col.flex = field["flex"];
                }

                if (field.hasOwnProperty('width')) {
                    col.width = field["width"];
                }

                if (field.title === "Actions") {
                    //col.pinned = 'right';
                    col.filter = false;
                    col.cellRenderer = 'setAction';
                    col.cellRendererParams = {
                        clicked: function (field) {
                            // alert(`${field} was clicked`);
                        }
                    };
                }

                if (field.hasOwnProperty('html')) {
                    col.cellRenderer = 'ishtml';
                }

                app.desktopDefaultCols.push(col);
            });
        }

        if (this.isSmall) {
            this.defaultCols = this.desktopDefaultCols;
            this.defaultColCount = this.defaultCols.length;
        } else {
            this.defaultCols = this.desktopDefaultCols;
            this.defaultColCount = this.defaultCols.length;
        }

        this.gridOptions = {
            statusBar: {
                statusPanels: [
                    {statusPanel: 'agTotalAndFilteredRowCountComponent', key: 'totalAndFilter', align: 'left'},
                    {statusPanel: 'agSelectedRowCountComponent', align: 'left'},
                    {statusPanel: 'agAggregationComponent', align: 'right'}
                ]
            },
            defaultColDef: {
                minWidth: 50,
                sortable: false,
                group: false,
                filter: true,
                floatingFilter: !app.isSmall,
                resizable: true
            },
            components: {
                setAction: app.setAction,
                ishtml: app.ishtml,
            },
            rowHeight: this.rowHeight,
            enableCellChangeFlash: false,
            rowDragManaged: false,
            // suppressMoveWhenRowDragging: true,
            enableMultiRowDragging: true,
            // enableBrowserTooltips: true,valueCache
            // tooltipShowDelay: 200,
            // ensureDomOrder: true,
            // enableCellTextSelection: true,
            // postProcessPopup: function(params) {
            //     console.log(params);
            // },
            // need to be careful here inside the normal demo, as names are not unique if big data sets
            // getRowNodeId: function(data) {
            //     return data.name;
            // },
            // suppressAsyncEvents: true,
            // suppressAggAtRootLevel: true,
            debug: false,
            // editType: 'fullRow',
            // debug: true,
            // suppressMultiRangeSelection: true,
            rowGroupPanelShow: 'of', /*app.isSmall ? undefined : 'always', // on of ['always','onlyWhenGrouping']*/
            suppressMenuHide: app.isSmall,
            pivotPanelShow: 'of', // on of ['always','onlyWhenPivoting']
            // suppressExpandablePivotGroups: true,
            // pivotColumnGroupTotals: 'before',
            // pivotRowTotals: 'before',
            // suppressRowTransform: true,
            // minColWidth: 50,
            // maxColWidth: 300,
            rowBuffer: 5,
            rowModelType: 'serverSide',
            infiniteInitialRowCount: 1,
           // serverSideStoreType: 'partial',
            cacheBlockSize: 100,
            maxBlocksInCache:1,
            columnDefs: app.desktopDefaultCols,
            // singleClickEdit: true,
            // suppressClickEdit: true,
            // suppressClipboardApi: true,
            enterMovesDownAfterEdit: true,
            enterMovesDown: true,
            // domLayout: 'autoHeight',
            // domLayout: 'forPrint',
            // groupUseEntireRow: true, //one of [true, false]
            // groupDefaultExpanded: 9999, //one of [true, false], or an integer if greater than 1
            // headerHeight: 100, // set to an integer, default is 25, or 50 if grouping columns
            // groupSuppressAutoColumn: true,
            // pivotSuppressAutoColumn: true,
            // groupSuppressBlankHeader: true,
            // suppressMovingCss: true,
            // suppressMovableColumns: true,
            // groupIncludeFooter: true,
            // groupIncludeTotalFooter: true,
            // suppressHorizontalScroll: true,
            // alwaysShowHorizontalScroll: true,
            // alwaysShowVerticalScroll: true,
            debounceVerticalScrollbar: true,
            suppressColumnMoveAnimation: app.suppressColumnMoveAnimation(),
            // suppressRowHoverHighlight: true,
            // suppressTouch: true,
            // suppressDragLeaveHidesColumns: true,
            // suppressMakeColumnVisibleAfterUnGroup: true,
            // unSortIcon: true,
            enableRtl: /[?&]rtl=true/.test(window.location.search),
            enableCharts: true,
            // multiSortKey: 'ctrl',
            animateRows: true,

            enableRangeSelection: true,
            // enableRangeHandle: true,
            enableFillHandle: true,
            undoRedoCellEditing: true,
            undoRedoCellEditingLimit: 50,

            suppressClearOnFillReduction: false,

            rowSelection: 'multiple', // one of ['single','multiple'], leave blank for no selection
            // suppressRowDeselection: true,
            quickFilterText: null,
            groupSelectsChildren: true, // one of [true, false]
           // pagination: true,
            //paginateChildRows: true,
            //paginationPageSize: 100,
            //groupSelectsFiltered: true,
           // suppressRowClickSelection: true, // if true, clicking rows doesn't select (useful for checkbox selection)
            // suppressColumnVirtualisation: true,
            // suppressContextMenu: true,
            // suppressFieldDotNotation: true,
            autoGroupColumnDef: app.groupColumn,
            // suppressActionCtrlC: true,
            // suppressActionCtrlV: true,
            // suppressActionCtrlD: true,
            // suppressActionCtrlA: true,
            // suppressCellSelection: true,
            // suppressMultiSort: true,
            // scrollbarWidth: 20,
            aggFuncs: {
                'zero': function () {
                    return 0;
                }
            },
            getBusinessKeyForNode: function (node) {
                return node.data ? node.data.name : '';
            },
            defaultGroupSortComparator: function (nodeA, nodeB) {
                if (nodeA.key < nodeB.key) {
                    return -1;
                }
                if (nodeA.key > nodeB.key) {
                    return 1;
                }

                return 0;

            },
            processCellFromClipboard: function (params) {
                var colIdUpperCase = params.column.getId().toUpperCase();
                var monthsUpperCase = months.map(function (month) {
                    return month.toUpperCase();
                });
                var isMonth = monthsUpperCase.indexOf(colIdUpperCase) >= 0;

                if (isMonth) {
                    return sharedNumberParser(params.value);
                }

                return params.value;
            },

            onRowClicked: function (params) {

            },
            onRowDoubleClicked: function (params) {

            },
            onGridSizeChanged: function (params) {

            },
            // callback when cell clicked
            onCellClicked: function (params) {
                // console.log("Callback onCellClicked: " + params.value + " - " + params.colDef.field + ' - ' + params.event);
            },
            onColumnVisible: function (event) {
                console.log("Callback onColumnVisible:", event);
            },
            onColumnResized: function (event) {

            },
            onCellValueChanged: function (params) {

            },
            onRowDataChanged: function (params) {
                console.log('Callback onRowDataChanged: ');
            },
            // callback when cell double clicked
            onCellDoubleClicked: function (params) {
                // console.log("Callback onCellDoubleClicked: " + params.value + " - " + params.colDef.field + ' - ' + params.event);
            },
            // callback when cell right clicked
            onCellContextMenu: function (params) {
                console.log("Callback onCellContextMenu: " + params.value + " - " + params.colDef.field + ' - ' + params.event);
            },
            onCellFocused: function (params) {
                // console.log('Callback onCellFocused: ' + params.rowIndex + " - " + params.colIndex);
            },
            onPasteStart: function (params) {
                console.log('Callback onPasteStart:', params);
            },
            onPasteEnd: function (params) {
                console.log('Callback onPasteEnd:', params);
            },
            onGridReady: function (event) {
                console.log('Callback onGridReady: api = ' + event.api);
                /* if (app.docEl.clientWidth <= 1024) {
                     event.api.closeToolPanel();
                 }*/
            },
            onRowGroupOpened: function (event) {
                console.log('Callback onRowGroupOpened: node = ' + event.node.key + ', ' + event.expanded);
            },
            onRangeSelectionChanged: function (event) {
                // console.log('Callback onRangeSelectionChanged: finished = ' + event.finished);
            },
            getContextMenuItems: this.getContextMenuItems,
            excelStyles: [
                {
                    id: 'vAlign',
                    alignment: {
                        vertical: 'Center'
                    }
                },
                {
                    id: 'alphabet',
                    alignment: {
                        vertical: 'Center'
                    }
                },
                {
                    id: 'good-score',
                    alignment: {
                        horizontal: 'Center',
                        vertical: 'Center'
                    },
                    interior: {
                        color: "#C6EFCE", pattern: 'Solid'
                    },
                    numberFormat: {
                        format: '[$$-409]#,##0'
                    }
                },
                {
                    id: 'bad-score',
                    alignment: {
                        horizontal: 'Center',
                        vertical: 'Center'
                    },
                    interior: {
                        color: "#FFC7CE", pattern: 'Solid'
                    },
                    numberFormat: {
                        format: '[$$-409]#,##0'
                    }
                },
                {
                    id: 'header',
                    font: {
                        color: "#44546A",
                        size: 16
                    },
                    interior: {
                        color: '#F2F2F2',
                        pattern: 'Solid'
                    },
                    alignment: {
                        horizontal: 'Center',
                        vertical: 'Center'
                    },
                    borders: {
                        borderTop: {
                            lineStyle: 'Continuous',
                            weight: 0,
                            color: '#8EA9DB'
                        },
                        borderRight: {
                            lineStyle: 'Continuous',
                            weight: 0,
                            color: '#8EA9DB'
                        },
                        borderBottom: {
                            lineStyle: 'Continuous',
                            weight: 0,
                            color: '#8EA9DB'
                        },
                        borderLeft: {
                            lineStyle: 'Continuous',
                            weight: 0,
                            color: '#8EA9DB'
                        }
                    }
                },
                {
                    id: 'currencyCell',
                    alignment: {
                        horizontal: 'Center',
                        vertical: 'Center'
                    },
                    numberFormat: {
                        format: '[$$-409]#,##0'
                    }
                },
                {
                    id: 'booleanType',
                    dataType: 'boolean',
                    alignment: {
                        vertical: 'Center'
                    }
                },
                {
                    id: 'countryCell',
                    alignment: {
                        indent: 4
                    }
                }
            ]
        }
        document.addEventListener('DOMContentLoaded', function () {
            app.onThemeChanged(true);
        });


    }
}
</script>

<style scoped>

</style>
